import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class InvoicesFeatureGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> {
    if (!!this.authService.authUser.getValue()?.featureFlags?.invoices) {
      return true;
    }

    await this.router.navigate(['/deals'], {
      queryParams: state?.root?.queryParams,
    });
    return false;
  }
}
